import { render, staticRenderFns } from "./ScanRecordAddImg.vue?vue&type=template&id=66b7d161&"
import script from "./ScanRecordAddImg.vue?vue&type=script&lang=js&"
export * from "./ScanRecordAddImg.vue?vue&type=script&lang=js&"
import style0 from "./ScanRecordAddImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports